/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Trig_Cur_ThresholdInputs */



/**
* | output |
* | --- |
* | "Threshold: {value}" |
*
* @param {Trig_Cur_ThresholdInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const trig_cur_threshold = /** @type {((inputs: Trig_Cur_ThresholdInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trig_Cur_ThresholdInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Threshold: ${i?.value}`)
	return /** @type {LocalizedString} */ (`Seuil: ${i?.value}`)
});